import React from 'react';
import styled from 'styled-components';

import { FilestackImageData } from 'api/types/shared.types';
import Box from 'components/Box';
import { Image } from 'components/Image';
import { breakpoints } from 'theme';
import { getImageSrc } from 'utils/getImageSrc';

const MobileBannerImage = styled(Image)`
  display: block;
  @media (min-width: ${breakpoints[3]}) {
    display: none;
  }
`;

type Props = {
  image: FilestackImageData;
  convert?: boolean;
  alwaysShow?: boolean;
};

export function MobileBanner({ image, convert, alwaysShow }: Props) {
  const isSvg = image.mimetype.includes('image/svg');

  const imageSrc = getImageSrc({
    handle: image.handle,
    width: 992,
    height: 605,
    format: convert ? 'jpg' : undefined,
    mimetype: image.mimetype,
  });

  const imageSrc2x = getImageSrc({
    handle: image.handle,
    width: 1984,
    height: 1210,
    format: convert ? 'jpg' : undefined,
    mimetype: image.mimetype,
  });

  return (
    <Box display={['block', null, null, 'none']} height="100%">
      <MobileBannerImage
        width={992}
        height={605}
        alt={getText('Hero image')}
        src={imageSrc}
        srcSet={`${imageSrc}, ${imageSrc2x} 2x`}
        alwaysShow={alwaysShow}
        svg={isSvg}
      />
    </Box>
  );
}
